<template>
  <section class="forHome engagements">
    <Grid class="engagements-grid forHome">
      <div class="grid-column x4">
        <div class="content txt">
          <h2>Engagements</h2>
        </div>
      </div>
      <div class="grid-column x6 shrinkTo4">
        <div class="content txt">
          <p class="organisations">
            Birds on Mars, Brandbook, Cyberport, EMI Musik, Fielmann AG, Fielmann Ventures, Linotype, Merck, Musikhaus Kirstein, Nuuna, Preciose Design Studio, Schott, 
            Visable and a lot of local heroes based in my hometown*
          </p>
        </div>
      </div>
      <div class="grid-column x3 shrinkTo4">
        <div class="content txt">
          <p>
            <span class="smallprint">
              * I was never interested in collecting trophies for my logo
              wallpaper. I picked my engagements based on the people who were
              involved and if the work was interesting.
            </span>
          </p>
        </div>
      </div>
      <div class="grid-column fortuneCookie">
        <img class="fortuneCookie-img" src="static/img/fortune-cookie.jpg" />
        <div class="fortuneCookie-label">
          Testimonial from
          <span>fortune cookie</span>
        </div>
      </div>
    </Grid>
  </section>
</template>
<script>
import Grid from "./Grid.vue";
export default {
  name: "Engagements",
  components: {
    Grid
  }
};
</script>
<style scoped>
.engagements {
  background-color: var(--GREY);
}

.engagements-grid {
  flex-wrap: nowrap;
  align-items: flex-start;
  flex-direction: column;
  align-content: flex-start;
  justify-content: center;
}

.organisations {
  font-size: 30px;
  line-height: 40px;
  letter-spacing: -0.75px;
}

@media only screen and (max-width: 576px) {
  .items {
    font-size: 30px;
    line-height: 40px;
    letter-spacing: -0.75px;
  }
}

.fortuneCookie {
  position: relative;
  padding-top: calc(var(--LINE-HEIGHT) * 2);
}

.fortuneCookie-img {
  width: calc(var(--COLUMN-SIZE) * 4 - var(--EXTRA-SPACE-LEFT));
  margin-left: var(--EXTRA-SPACE-LEFT);
}

@media only screen and (max-width: 576px) {
  .fortuneCookie-img {
    width: 100%;

    margin-left: var(--EXTRA-SPACE-LEFT);
  }
}

.fortuneCookie-label {
  position: absolute;
  top: calc(var(--LINE-HEIGHT) * 7);
  left: calc(var(--COLUMN-SIZE) * 4);
  width: calc(var(--COLUMN-SIZE) * 2.5);
  font-size: 20px;
  line-height: 20px;
  letter-spacing: -0.5px;
  position: absolute;
  display: inline-block;
  font-family: "Urby-Regular", Arial, Helvetica, sans-serif;
  mix-blend-mode: normal;
  text-align: right;
}

.fortuneCookie-label:after {
  content: " ";
  position: absolute;
  left: -75px;
  right: 0;
  bottom: -1.5px;
  height: 1.5px;
  background-color: var(--BLACK);
}

@media only screen and (max-width: 576px) {
  .fortuneCookie-label {
    position: relative;
    width: 100%;
    line-height: calc(var(--LINE-HEIGHT) * 2);
    text-decoration: underline;
    text-decoration-thickness: 1.5px;
    text-underline-offset: 3px;
    left: 0;
    right: 0;
    top: 0;
  }
  .fortuneCookie-label:after {
    display: none;
  }
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .fortuneCookie-label {
    position: relative;
    width: 100%;
    line-height: calc(var(--LINE-HEIGHT) * 2);
    text-decoration: underline;
    text-decoration-thickness: 1.5px;
    text-underline-offset: 3px;
    left: 0;
    right: 0;
    top: 0;
  }
  .fortuneCookie-label:after {
    display: none;
  }
}
@media only screen and (min-width: 768px) and (max-width: 992px) {
  .fortuneCookie-label {
    top: calc(var(--LINE-HEIGHT) * 6);
    left: calc(var(--COLUMN-SIZE) * 4);
    width: calc(var(--COLUMN-SIZE) * 3);
  }
  .fortuneCookie-label:after {
    left: -55px;
  }
}
@media only screen and (min-width: 992px) {
}
</style>



// WEBPACK FOOTER //
// src/components/Section.Engagements.vue